module.exports = __webpack_public_path__ + "static/img/color-cartridge_64.1bfdf6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color-cartridge_64.png
// module id = PEFZ
// module chunks = 0